import { takeLatest, put, call } from 'redux-saga/effects';
import { setAuthTokens, clearAuthTokens } from 'axios-jwt';

import { UserProfile } from '@models/UserProfile';
import { AuthApi } from '@apis/AuthApi';
import { SagaPayload } from '@utils/typescript';

import {
  currentUserSignOut,
  accessTokenSet,
  currentUserSet,
  currentUserFetch,
} from './action';

function* handleAccessTokenSet({ payload }: SagaPayload<string>) {
  yield call(setAuthTokens, { accessToken: payload, refreshToken: payload });
  yield put(currentUserFetch());
}

function* handleCurrentUserSignOut() {
  yield call(clearAuthTokens);
  yield put(currentUserSet(null));
}

function* handleCurrentUserFetch() {
  try {
    const currentUser = (yield call(AuthApi.getUserProfile)) as UserProfile;
    yield put(currentUserSet(currentUser));
  } catch {
    yield put(currentUserSet(null));
  }
}

export default function* () {
  yield takeLatest(accessTokenSet, handleAccessTokenSet);
  yield takeLatest(currentUserSignOut, handleCurrentUserSignOut);
  yield takeLatest(currentUserFetch, handleCurrentUserFetch);
}
